import HttpFactory from '../factory'
import type { AccessToken, CallParticipantAccess } from '../types/video-call/auth'
import type { VideoCall } from '../types/video-call/videoCall'

class VideoCallModule extends HttpFactory<any[]> {
  private PATH = '/v2/video-calls'
  async get(): Promise<VideoCall[]> {
    let result = null
    try {
      result = await this.call<any>('POST', `${this.PATH}`)
    } catch (err) {
      console.error(err)
    }
    return result
  }
  async videoCallAuth(accessCode: string): Promise<any> {
    let result = null
    try {
      result = await this.call<any>(
        'POST',
        `${this.PATH}/login`,
        { accessCode: accessCode.toString() },
        { notAuthorizeException: true },
      )
    } catch (err: any) {
      throw {
        ...err,
        source: 'videoCallAuth',
      }
    }
    return result
  }

  async addParticipant(videoId: string, invitation: any): Promise<CallParticipantAccess> {
    return await this.call<any>('POST', `${this.PATH}/${videoId}/participants`, invitation)
  }

  async addParticipantV2(videoId: string, invitation: any): Promise<CallParticipantAccess> {
    return await this.call<any>('POST', `${this.PATH}/${videoId}/participants`, invitation)
  }

  async sendInvite(videoId: string, invitation: any, participantAccessId: string): Promise<CallParticipantAccess> {
    return await this.call<any>('PUT', `${this.PATH}/${videoId}/participants/${participantAccessId}/invitation`, invitation)
  }
  async sendInviteV2(videoId: string, invitation: any, participantAccessId: string): Promise<CallParticipantAccess> {
    return await this.call<any>('PUT', `${this.PATH}/${videoId}/participants/${participantAccessId}/invitation`, invitation)
  }
}

export default VideoCallModule
